import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/alipay': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M377.7 32H70.3C31.4 32 0 63.4 0 102.3V409.7C0 448.6 31.4 480 70.3 480H377.7C416.3 480 447.5 448.9 448 410.4 402 384.8 337.4 350.1 276.4 322 244.3 365.9 192.3 403 127.8 403 57.2 403 34 357.7 30.7 326.6 26.8 287.6 45.6 245.1 130.3 245.1 165.6 245.1 209.6 255.3 257.4 270 273.9 240 283.8 209.7 283.8 209.7H105.6V193H197.7V161.8H88.3V142.8H197.7V92.3H248.6V142.8H358.1V161.8H248.6V193H337.4S322.2 239.6 299.1 283.9C348 300.6 399.1 320 447.7 336.7V102.3C447.8 63.6 416.4 32 377.7 32zM47.3 322.9C48.3 343.1 57.5 376.7 117.2 376.7 169.3 376.7 209.8 337 235.1 303.8 190.4 285.1 150.6 272.4 125.6 272.4 58.2 272.4 46.3 305.4 47.3 322.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/alipay.js
// module id = Rtpx
// module chunks = 144